import { createRequestActionTypes } from '../../helpers'

export const FETCH_FAQ = createRequestActionTypes('FREENAV', 'FETCH_FAQ')
